import React from 'react';
import { Dropdown } from 'react-bootstrap';

/**
 * The "Select School Year" control shared by classroom.js / eventPrograms.js.
 *
 * Props:
 *   list      array of { id, school_year }
 *   selected  currently selected year id
 *   onChange  native <select> change handler
 *   label     optional heading (default "Select School Year")
 */
const SchoolYearPicker = ({ list = [], selected, onChange, label = 'Select School Year' }) => (
  <div>
    <Dropdown>
      <span className="fw-bold">{label}</span>
      <select value={selected ?? ''} onChange={onChange}>
        <option value="" disabled>
          {label}
        </option>
        {list.map((year) => (
          <option key={year.id} value={year.id}>
            {year.school_year}
          </option>
        ))}
      </select>
    </Dropdown>
  </div>
);

export default SchoolYearPicker;
